import { MaintenanceDocumentComponent } from "./document";
import { ElLoading } from "element-plus";


export class CloudMaintenanceDocumentComponent extends MaintenanceDocumentComponent {
}